import { EEntranceType } from '../../../packages/api-models/common/json_query';

const SEPARATE_ENTRANCE_TYPES: readonly EEntranceType[] = [
  EEntranceType.SeparateStreet,
  EEntranceType.SeparateCourtyard,
];

/**
 * Собирает термин `input_type` из выбранного направления входа и флага «Отдельный вход»
 * (единственный термин входа, который фильтрует бэкенд; `is_separated_input_type` он игнорирует).
 * Повторяет логику веба (getJsonQueryInputType): с флагом — только отдельные входы,
 * без флага — отдельные + общие входы того же направления.
 */
export function buildEntranceInputType(
  directions: readonly EEntranceType[],
  isSeparate: boolean,
): EEntranceType[] | null {
  if (isSeparate) {
    const separated = directions.length
      ? directions.filter(type => SEPARATE_ENTRANCE_TYPES.includes(type))
      : [...SEPARATE_ENTRANCE_TYPES];

    return separated.length ? separated : null;
  }

  const result = directions.reduce<EEntranceType[]>((accumulator, type) => {
    accumulator.push(type);

    if (type === EEntranceType.SeparateStreet) {
      accumulator.push(EEntranceType.CommonStreet);
    }

    if (type === EEntranceType.SeparateCourtyard) {
      accumulator.push(EEntranceType.CommonCourtyard);
    }

    return accumulator;
  }, []);

  return result.length ? result : null;
}

/**
 * Обратное преобразование термина `input_type` в состояние контролов: какие направления
 * активны и включён ли «Отдельный вход» (флаг активен, если все значения — отдельные входы).
 */
export function parseEntranceState(inputType: readonly EEntranceType[] | null): {
  directions: EEntranceType[];
  isSeparate: boolean;
} {
  const values = inputType ?? [];
  const directions: EEntranceType[] = [];

  if (values.includes(EEntranceType.SeparateStreet) || values.includes(EEntranceType.CommonStreet)) {
    directions.push(EEntranceType.SeparateStreet);
  }

  if (values.includes(EEntranceType.SeparateCourtyard) || values.includes(EEntranceType.CommonCourtyard)) {
    directions.push(EEntranceType.SeparateCourtyard);
  }

  const isSeparate = values.length > 0 && values.every(type => SEPARATE_ENTRANCE_TYPES.includes(type));

  return { directions, isSeparate };
}
